import { Button, Modal, Label } from "flowbite-react";
import { useEffect, useState } from "react";
import Select from "react-select";
import { useGetClientsQuery } from "@/api/clientApi/client";
import { useTranslation } from "react-i18next";

interface ClientAssignmentDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (clientIds: number[]) => void;
}

export default function ClientAssignmentDialog({
  open,
  onClose,
  onSubmit,
}: ClientAssignmentDialogProps) {
  const { t } = useTranslation(["clientGroup", "common"]);
  const [selectedClients, setSelectedClients] = useState<
    { label: string; value: number }[]
  >([]);
  const [clientOptions, setClientOptions] = useState<
    { label: string; value: number }[]
  >([]);

  const { data: clientsData, isLoading } = useGetClientsQuery({
    pageSize: "100",
    is_active: "true",
  });

  useEffect(() => {
    if (clientsData) {
      const items = clientsData.items || clientsData.data || [];
      const options = items.map((client: any) => ({
        label: client.client_username,
        value: client.client_id,
      }));
      setClientOptions(options);
    }
  }, [clientsData]);

  useEffect(() => {
    if (!open) {
      setSelectedClients([]);
    }
  }, [open]);

  const handleSubmit = () => {
    const ids = selectedClients.map((opt) => opt.value);
    onSubmit(ids);
  };

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Header>{t("clientGroup:assignClientsTitle")}</Modal.Header>
      <Modal.Body className="overflow-visible">
        <div className="space-y-4">
          <div className="mb-2 block">
            <Label value={t("clientGroup:selectClients")} />
          </div>
          <Select
            isMulti
            options={clientOptions}
            value={selectedClients}
            onChange={(selected) => setSelectedClients(selected as any)}
            isLoading={isLoading}
            placeholder={t("clientGroup:searchClientsPlaceholder")}
            className="basic-multi-select"
            classNamePrefix="select"
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button color="gray" onClick={onClose}>
          {t("common:cancel")}
        </Button>
        <Button onClick={handleSubmit}>{t("clientGroup:assign")}</Button>
      </Modal.Footer>
    </Modal>
  );
}
